<template>
  <form @submit.prevent="submit">
    <FormInput
      v-if="!token"
      name="name"
      v-model="fields.name"
      testId="name-input"
      :label="`${$t('global.name')} *`"
      :errors="validation.fields.name.errors"
      :dirty="validation.fields.name.dirty"
      :disabled="loading"
      class="mb-4"
    />
    <div v-if="token" class="mb-4">
      {{ $t("global.api-tokens-message") }}
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <FormTextArea v-if="token" v-model="token" :disabled="true" name="token" class="api-token" />
      <CopyToClipboard v-if="token" :text="token" :size="20" class="copy mb-3" />
    </div>
    <div class="form-buttons">
      <Btn
        v-if="token"
        variant="primary"
        type="button"
        @click="cancel"
        data-test="close-generate-api-token-button"
      >
        {{ $t("global.close") }}
      </Btn>
      <Btn
        v-if="!token"
        class="mr-2"
        variant="light"
        type="button"
        :disabled="loading"
        @click="cancel"
        data-test="cancel-generate-api-token-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        v-if="!token"
        variant="primary"
        type="submit"
        :disabled="!isSubmittable()"
        :loading="loading"
        data-test="generate-api-token-button"
      >
        {{ $t("global.generate") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import CopyToClipboard from "@/components/display/CopyToClipboard";
import FormInput from "@/components/display/form/FormInput";
import FormTextArea from "@/components/display/form/FormTextArea";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { apiToken as validationRules } from "leatherman-js/utils/validations/forms";

export default {
  name: "GenerateApiTokenForm",
  components: {
    CopyToClipboard,
    FormTextArea,
    FormInput,
    Btn,
  },
  setup(props, { emit, root }) {
    const loading = ref(false);
    const errors = ref(null);
    const token = ref(null);
    const fields = reactive({ name: null });
    const { validator } = useValidator();
    const validation = validator(
      fields,
      validationRules,
      {},
      {
        name: {
          required: root.$t("validation.name-required"),
        },
      }
    );

    const cancel = () => emit("close");
    const isSubmittable = () => !loading.value && validation.errors.length === 0;
    const submit = () => {
      errors.value = null;

      validation
        .validate()
        .then(() => {
          loading.value = true;
          store
            .dispatch("tokens/generateToken", fields.name)
            .then((response) => {
              token.value = response.token;
            })
            .catch(() => {
              store.dispatch("toasts/addToast", {
                variant: "error",
                message: root.$t("toasts.api-token-generate-error-message"),
              });
            })
            .finally(() => {
              loading.value = false;
            });
        })
        .catch(() => {});
    };
    return {
      errors,
      fields,
      loading,
      submit,
      token,
      validation,
      cancel,
      isSubmittable,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
.api-token {
  width: 80%;
}
.copy {
  width: 10%;
}
</style>
